import FeatureCard from './FeatureCard';
import {
  mdiMap,
  mdiTarget,
  mdiRobotOutline,
  mdiCameraOutline,
} from '@mdi/js';

interface FeaturesSectionProps {
  isMobile: boolean;
}

function FeaturesSection({ isMobile }: FeaturesSectionProps) {
  return (
    <div style={styles(isMobile).featuresSection}>
      <div style={styles(isMobile).featureCards}>
        <FeatureCard
          iconPath={mdiMap}
          title="Map-Based Social"
          description="No more static pins or stale reviews. Every location becomes a dynamic social space."
          isMobile={isMobile}
        />

        <FeatureCard
          iconPath={mdiTarget}
          title="Layer Communities"
          description='Create themed communities like "street art" or "food trucks" with your own moderation rules.'
          isMobile={isMobile}
        />

        <FeatureCard
          iconPath={mdiRobotOutline}
          title="AI-Powered Discovery"
          description='Search for "hidden murals" or "puppy playdate" and watch your map fill with matching content.'
          isMobile={isMobile}
        />

        <FeatureCard
          iconPath={mdiCameraOutline}
          title="Rich Media"
          description="Share photos, videos, audio recordings, and even live streams directly on the map."
          isMobile={isMobile}
        />
      </div>
    </div>
  );
}

export default FeaturesSection;

const styles = (isMobile: boolean) => ({
  featuresSection: {
    padding: isMobile ? '60px 20px' : '80px 20px',
    background: 'rgba(255, 255, 255, 0.5)',
    backdropFilter: 'blur(10px)',
  },

  featureCards: {
    display: 'grid',
    gridTemplateColumns: isMobile ? '1fr' : 'repeat(auto-fit, minmax(250px, 1fr))',
    gap: isMobile ? '30px' : '40px',
    maxWidth: '1000px',
    margin: '0 auto',
  },
});
